// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZmCl","title":"styles_title__3xqFA"};